export enum TagType {
    LABEL = 'Crm::PipelineLabel',
    BOARD = 'Crm::PipelineBoard',
}
